export default __webpack_public_path__ + "static/media/LO02b.977a5d29.mp3";